'use strict';

define('features/ctas/inventory.cta',[
  'jquery',
  './cta.types',
  'lib/util/tda.config',
  'firstMoverParticipant'
], function (
  $,
  ctaTypes,
  tdaConfig,
  fmp
) {
  var __type = ctaTypes['inventory']; // eslint-disable-line dot-notation
  var __defaultUrl = '/' + tdaConfig.site.context_url + '/inventory/';

  function __cleanParams(obj) {
    var newObj = obj;
    if (!newObj.series) {
      return {};
    }
    // if multi series, default to first one. works fine when series has no spaces
    newObj.series = newObj.series.split(' ')[0];
    Object.keys(newObj).forEach(function (key) {
      if (!newObj[key]) {
        delete newObj[key];
      }
    });
    Object.keys(newObj).forEach(function (key) {
      newObj[key] = String(newObj[key]).toLowerCase();
    });
    return newObj;
  }

  function __buildUrl(params) {
    if ($.isEmptyObject(params)) {
      return __defaultUrl;
    }
    return __defaultUrl + 'results?' + $.param(params);
  }

  // best possible seriesObj: { series: '', grade: '', year: '' };
  return function invCta(seriesObj, $scope) {
    var $ctaScope = $scope || $('body');
    var $ctas = $("a[data-destination='" + __type + "']", $ctaScope);
    var params = __cleanParams(seriesObj);

    if (!$ctas.length) {
      return;
    }

    $ctas.each(function () {
      $(this).attr('href', __buildUrl(params));
    });

    // It's all good, GXP CTAs can still get the each treatment above. In fact, they like it.
    // Note that on WWW, fmp.attachInventoryClicks provides us with the 'Looking for Inventory' modal
    // so, ironically, there is no need to use ./www click events here
    if (BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled') {
      fmp.attachInventoryClicks($ctas);
    }
  };
});

